import {useMutation} from '@tanstack/react-query';
import {message} from '@ui/i18n/message';
import {toast} from '@ui/toast/toast';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {apiClient, queryClient} from '../../http/query-client';
import {showHttpErrorToast} from '../../http/show-http-error-toast';
import {useUserNotifications} from '../dialog/requests/user-notifications';

export function useDeleteReadNotifications() {
  return useMutation({
    mutationFn: () => deleteReadNotifications(),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: useUserNotifications.key});
      toast(message('Read notifications deleted'));
    },
    onError: err => showHttpErrorToast(err),
  });
}

function deleteReadNotifications(): Promise<BackendResponse> {
  return apiClient.delete('notifications/read').then(r => r.data);
}
